import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useForkRef, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { useUpdateEffect } from '../../../internal/hooks';
import { DropdownPopover } from '../../../popover';
import { SelectInput, useControlledValue } from '../../internal';
import { useMultiSelectDesktopController } from './useMultiSelectDesktopController';
import { MultiSelectDesktopDropdown } from './MultiSelectDesktopDropdown';
import { processMultiSelectKeyboardEvent } from './processMultiSelectKeyboardEvent';

/**
 * select-компонент для выбора нескольких значений из списка
 *
 * Только десктопный вариант, открывающий выпадающий список
 */
export var MultiSelectDesktop = /*#__PURE__*/React.forwardRef(function MultiSelectDesktop(props, forwardedRef) {
  var onClick = props.onClick,
    selectInputProps = _objectWithoutProperties(props, _excluded);
  var inputRef = React.useRef(null);
  var ref = useForkRef(forwardedRef, inputRef);
  var _useControlledValue = useControlledValue(props, []),
    value = _useControlledValue.value,
    onChange = _useControlledValue.onChange;
  var _useMultiSelectDeskto = useMultiSelectDesktopController(_objectSpread(_objectSpread({}, props), {}, {
      value: value || [],
      onChange: onChange
    })),
    open = _useMultiSelectDeskto.open,
    focusedIndex = _useMultiSelectDeskto.focusedIndex,
    actions = _useMultiSelectDeskto.actions,
    allOptionLabel = _useMultiSelectDeskto.allOptionLabel;
  useUpdateEffect(function () {
    var inputNode = inputRef.current;
    if (!open && inputNode) {
      inputNode.focus();
    }
  }, [open], useIsomorphicLayoutEffect);
  var handleInputClick = React.useCallback(function (e) {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      e.stopPropagation();
      actions.toggleDropdown();
    }
  }, [actions, onClick]);
  var handleKeyDown = React.useCallback(function (e) {
    processMultiSelectKeyboardEvent(e, {
      open: open,
      actions: actions
    });
  }, [open, actions]);
  return /*#__PURE__*/React.createElement(DropdownPopover, {
    open: open,
    content: /*#__PURE__*/React.createElement(MultiSelectDesktopDropdown, _extends({}, props, {
      value: value,
      open: open,
      onKeyDown: handleKeyDown,
      focusedIndex: focusedIndex,
      actions: actions,
      allOptionLabel: allOptionLabel
    }))
  }, /*#__PURE__*/React.createElement(SelectInput, _extends({}, selectInputProps, {
    ref: ref,
    open: open,
    onClick: handleInputClick,
    onKeyDown: handleKeyDown,
    role: "button",
    "aria-haspopup": "listbox",
    value: value
  })));
});